import React from "react";

import "./table.m.css";

const Table = ({ element, story }) => {
  const content = element?.data?.content;
  function parseCSV(csvString) {
    const rows = csvString?.split("\n");
    const result = rows?.map((row) => {
      return row.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g)?.map((field) => field.replace(/(^"|"$)/g, ""));
    });
    return result;
  }
  const considerFirstRowAsHeader = element?.metadata?.["has-header"];
  const csvData = parseCSV(content);
  const theadData = csvData[0];
  const tbodyData = csvData.slice(1);
  return (
    <div styleName="table-container">
      <table styleName="table">
        {considerFirstRowAsHeader && (
          <thead styleName="table-header">
            <tr>
              {theadData.map((header, index) => {
                return <th key={`${header}-${index}`}>{header}</th>;
              })}
            </tr>
          </thead>
        )}
        <tbody styleName="table-body">
          {!considerFirstRowAsHeader && (
            <tr>
              {theadData?.map((header, index) => {
                return <td key={`${header}-${index}`}>{header}</td>;
              })}
            </tr>
          )}
          {tbodyData?.map((data, index) => {
            return (
              <tr key={`${data}-${index}`}>
                {data?.map((d, index) => {
                  return <td key={`${d}-${index}`}>{d}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
